// extracted by mini-css-extract-plugin
module.exports = {"root":"DropdownItem_root__12S5F","isSelected":"DropdownItem_isSelected__39ac3"};